export default {
  'form.required': '必須',
  'input.good': 'よい',
  // <!------ header --------!>
  'header.book': 'フライト',
  'header.upgradetobusiness': 'パートナーに変更',
  'header.checkin': '予約',
  'header.manage': 'ダッシュボード',
  'header.login': 'ログイン',
  'header.signup': 'サインアップ',
  'header.dashboard': 'ダッシュボード',
  'header.logout': 'ログアウト',
  'header.ticket': 'リクエスト',
  'header.Booking': '予約',
  'header.smarttripsi': 'Smart Tripsi',
  'header.smarttripord': 'Smart Tripord',
  'header.aboutus': '私たちに関しては',
  'header.contactus': 'お問い合わせ',
  // <!------ footer --------!>
  'footer.supports': 'サポート',
  'footer.onlinechat': 'オンラインでチャット',
  'footer.customer': 'カスタマーケアー',
  'footer.reserve': '予約者サポート',
  'footer.fax': 'ファックス',
  'footer.email': 'Email: Support.Tripsi.com',
  'footer.services': 'サービス内容',
  'footer.flight': 'フライト',
  'footer.hotel': 'ホテル',
  'footer.tour': 'ツアー',
  'footer.who': '自己紹介',
  'footer.aboutus': '私たちに関しては',
  'footer.contactus': 'お問い合わせ',
  'footer.members': 'メンバー',
  'footer.board': '役員',
  'footer.history': '社史',
  'footer.privacypolicy': '個人情報保護方針',
  'footer.privacy': '個人情報',
  'footer.claim': 'クレーム',
  'footer.rules': '規約',
  'footer.address': '住所',
  'footer.subscribe': 'ニュースの購読',
  'footer.copyright': 'Copyright © 2018 Tripsi Inc, All rights reserved',
  'footer.tourismMagazine': 'Tourism Magazine',
  'footer.customerClub': 'Customer Club',
  'footer.ticketGuide': 'Ticket Guide',
  'footer.english': '英語',
  'footer.persian': 'ペルシャ語',
  // <!------ aboutus --------!>
  'aboutus.tripsi': 'について Tripsi',
  'aboutus.tripord': 'について Tripord',
  'aboutus.tripsiAboutus': `トロ航空旅行および巡礼サービス会社 は、1373 年に大規模な観光産業で活動を開始しました。テヘランの販売部門とシーラーズの技術部門を含む 25 人以上の従業員を擁する Tolo の大規模なチームは、常に最高のサービスと最高品質のソフトウェアを提供することを目指しています。 現在のプロバイダーを満足させるために。 この会社は、1401 年に Tripsi という名前でオンラインの観光サービスの分野で活動を開始しました。Tripsi システムのポリシーは、顧客と利害関係者の満足と、顧客に優れた独自のサービスを提供することに基づいています。`,
  'aboutus.tripordAboutus': `Tripordは、単なるオンライン旅行プラットフォームではありません。私たちは、夢の旅を忘れられない体験へと変える信頼できるパートナーです。
2021年に設立されたTripordは、20年以上の業界経験を背景に、あらゆるニーズに正確かつ丁寧に応える、シームレスで革新的な旅行エコシステムの構築を使命としています。
Tripordでは、優れた旅行体験を提供するだけでなく、持続可能な未来の構築にも取り組んでいます。エコツーリズムの推進や自然の目的地の保護、地域コミュニティの支援を通じて、すべての旅を意義あるものにすることを目指しています。`,
  'aboutus.service1_tripsi': 'すべての国内および国際航空会社の代表',
  'aboutus.service2_tripsi': '都市間切符の海外販売代理店',
  'aboutus.service3_tripsi':
    '体系的かつチャーター的に外国のチケットを販売するための代理店',
  'aboutus.service4_tripsi': '国内切符の体系的・貸切販売代理店',
  'aboutus.service5_tripsi': '国際列車のチケット代理店',
  'aboutus.service6_tripsi': '海外からの発券（SOTO）',
  'aboutus.service7_tripsi': '国内・海外ツアーの企画・準備',
  'aboutus.service8_tripsi': '専門セミナー・カンファレンスの開催',
  'aboutus.service9_tripsi':
    '（大使館での時間とパスポートの受け取りを含む）ビザ関連サービスおよび大使館サービスの提供',
  'aboutus.service10_tripsi': '空港手続き転送サービス（CIP）の提供',
  'aboutus.service11_tripsi': 'イランと世界中のホテル予約',
  'aboutus.service12_tripsi':
    'ハッジと巡礼の監督の下で、巡礼キャラバン、巡礼とウムラを組織する',
  'aboutus.service1_tripord':
    'Tripordについて : 旅を再定義し、ひとつひとつの旅を大切に。Tripordでは、旅はシームレスでパーソナライズされた、忘れられない体験であるべきだと考えています。私たちの使命は、スマートなソリューション、厳選された体験、24時間365日のサポートを一つのプラットフォームで提供することで、世界の探求方法を変えることです。ラグジュアリーな滞在、エコツーリズム、隠れた名所、農場リトリートまで、競争力のある価格で特別な冒険をご提供します。',
  'aboutus.service2_tripord': 'なぜTripordを選ぶのか？',
  'aboutus.service3_tripord':
    '• オールインワンプラットフォーム：フライト、宿泊、ツアーなど、あなたのニーズに合わせた提案。',
  'aboutus.service4_tripord':
    '• 革新性と信頼：最先端の技術、安全な予約、透明性のある価格設定。',
  'aboutus.service5_tripord':
    '• 価値ある特典：Tripordロイヤルティクラブでポイントを貯めて交換。',
  'aboutus.service6_tripord':
    '• 専任サポート：365日、いつでもどこでもサポートいたします。',
  'aboutus.service7_tripord':
    '• サステナブルな旅：エコフレンドリーな観光と地域社会への貢献を推進。',
  'aboutus.service8_tripord':
    '専門知識と探求への情熱に支えられ、Tripordは単なる旅行サービスではなく、インスピレーションあふれる旅を創る信頼できるパートナーです。',
  'aboutus.service9_tripord': 'もっと探求、もっと安心。',
  'aboutus.address':
    'テヘラン、ヴァリアスル通り、ザファラニエ上、リファ銀行の隣、NO 3061、2階、ユニット6',
  'aboutus.company': 'Tripsi company',
  'aboutus.iranphone': '021-22749095',
  'aboutus.canadaaddress': 'Address : 719-938 HOWS STREET, VANCOUVER',
  'aboutus.canadaphone': '001-7786828070',
  //<!------- dashboard ---------!>
  'dashboard.flightDescriptionTripsi':
    'Tripsiで国内線および国際線の航空券を最安値で購入しましょう',
  'dashboard.flightDescriptionTripord':
    'Tripordで国内線および国際線の航空券を最安値で購入しましょう',
  'dashboard.overview': '概要',
  'dashboard.book': '予約',
  'dashboard.search': '検索',
  'dashboard.reserve': '発行',
  'dashboard.staffs': 'スタッフ',
  'dashboard.random': 'ランダム',
  'dashboard.stats': '統計',
  'dashboard.overalview': '概要',
  'dashboard.lastactivities': '最後のアクティビティー',
  'dashboard.opportunities': '機会',
  'dashboard.tickets': '購入済みチケット',
  'dashboard.open': 'ニュース　',
  'dashboard.rating': 'グレード',
  'dashboard.openrequest': 'リクエストを開く',
  'dashboard.derik': 'デリックポイント',
  'dashboard.showmore': 'もっと見る',
  'dashboard.onlinetickets': 'オンラインチケット',
  'dashboard.favoritetrips': '私のお気に入りの旅行',
  'dumb.amount_of_new_users': '新ユーザー数',
  'dumb.display_width': '<strong>Width: {width}</strong>',
  'dumb.display_height': '<strong>Height: {height}</strong>',
  //<!------ confirmation ---------!>
  'confirmation.reject': 'いいえ',
  'confirmation.confirm': 'はい',
  'confirmation.confirmTitle': '確認',
};
